import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import structureTypes from '../../../../common/constants/structureTypes'
import ServerPage from '../../../../server/types/ServerPageInterface'
import { migrateUpsellButton } from './migrateUpsellButtons'

export default function (page: ServerPage): [ServerPage, boolean] {
  let isChanged = false
  try {
    const entities = Object.values(page.content.entities).reduce(
      (prev, entity) => {
        if (
          entity.type === structureTypes.PAYMENT_BUTTON_AGREE ||
          entity.type === structureTypes.PAYMENT_BUTTON_DISAGREE
        ) {
          isChanged = true
        }

        return {
          ...prev,
          [entity.id]:
            entity.type === structureTypes.PAYMENT_BUTTON_AGREE ||
            entity.type === structureTypes.PAYMENT_BUTTON_DISAGREE
              ? migrateUpsellButton(entity as OldEntityInterface)
              : entity,
        }
      },
      {},
    )

    return [
      {
        ...page,
        content: {
          ...page.content,
          entities,
        },
      },
      isChanged,
    ]
  } catch (e) {
    console.log(`--error--`, page, page.id)

    return [page, false]
  }
}
